import React, { useState, useContext } from "react";
import { Modal, ModalBody } from "@windmill/react-ui";
import { SidebarContext } from "context/SidebarContext";
import { IoIosClose } from "react-icons/io";
import CommonCloseBtn from "components/CloseButton/CommonCloseButton";

const ViewModal = ({ id, title, data }) => {
  const { isViewModalOpen, closeModal } = useContext(SidebarContext);
  var result = data.find((item) => item.id === id);

  const [activeTab, setActiveTab] = useState("1");

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  const openZoomModal = (image) => {
    setSelectedImage(image);
    setIsModalOpen(true);
  };

  const closeZoomModal = () => {
    setSelectedImage(null);
    setIsModalOpen(false);
  };
  const renderImage = (image, i) => {
    return (
      <img
        className="inline-flex border rounded-md border-gray-100 dark:border-gray-600 w-24 max-h-24 p-2 m-2"
        src={process.env.REACT_APP_API_IMAGE_URL + image}
        alt="Preview"
      />
    );
  };
  const style = `{
    .custom-modal button {
      position: absolute;
      top: 10px;
      right: 10px;
      background-color: transparent;
      border: none;
      cursor: pointer;
      font-size: 16px;
      color: #333;
      outline:none !important;
    }
    .custom-modal button:hover {
      color: #FF0000 !important; 
      outline:none;
      
    } .custom-modal button:focus {
      color: #FF0000 !important; 
      outline:none; 
    }
    .custom-modal {
      overflow: auto;
    }
    
    `;

  return (
    <>
      <style>{style}</style>

      <Modal
        className="relative bg-white dark:bg-gray-700 dark:text-white p-2 w-1/2 rounded-md"
        isOpen={isViewModalOpen}
        onClose={() => {
          setActiveTab("1");
          closeModal();
        }}
      >
        <ModalBody className="custom-modal" style={{ margin: "0" }}>
          <CommonCloseBtn
           onClose={closeModal}
          />
          <h2 className="text-center font-bold text-lg">
            Advertisement Details
          </h2>

          {/* Tab Content */}
          <div className="p-4 max-h-96 overflow-y-auto">
            {activeTab === "1" && (
              <div
                className="flow-root rounded-lg border border-gray-300 dark:border-gray-600 py-3 shadow-sm"
                style={{ maxHeight: "400px" }}
              >
                <dl className="text-sm dark:text-white">
                  <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                    <dt className="font-medium text-gray-900 dark:text-white">
                      Tilte
                    </dt>
                    <dd className="text-gray-700 dark:text-white sm:col-span-2 pl-20">
                      {result?.title}
                    </dd>
                  </div>

                  <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                    <dt className="font-medium text-gray-900 dark:text-white">
                      URL
                    </dt>
                    <dd className="text-gray-700 dark:text-white sm:col-span-2 pl-20">
                      {result?.url}
                    </dd>
                  </div>
                  <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                    <dt className="font-medium text-gray-900 dark:text-white">
                      Content{" "}
                    </dt>
                    <dd className="text-gray-700 dark:text-white sm:col-span-2 pl-20">
                      {result?.content}
                    </dd>
                  </div>

                  <div className="grid grid-cols-1 gap-1 p-1 sm:grid-cols-3 sm:gap-4">
                    <dt className="font-medium text-gray-900 dark:text-white pl-3">
                      Image
                    </dt>
                    <dd
                      className="text-gray-700 dark:text-white sm:col-span-2 pl-20"
                      onClick={() => openZoomModal(result.ad_image_1)}
                    >
                      {result && Array.isArray(result.ad_image_1) && (
                        <>
                          {result.ad_image_1.map((image, i) =>
                            renderImage(image, i)
                          )}
                        </>
                      )}

                      {result &&
                        result.ad_image_1 &&
                        renderImage(result.ad_image_1)}
                    </dd>
                  </div>
                </dl>
              </div>
            )}

            {isModalOpen && (
              <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
                <div className="bg-white dark:bg-gray-600 p-4 rounded-lg max-w-md w-full relative">
                  <button
                    onClick={closeZoomModal}
                    className="viewModelBoxCloseBtn bg-white dark:bg-gray-600 dark:text-white"
                  >
                    <IoIosClose />
                  </button>

                  <img
                    src={process.env.REACT_APP_API_IMAGE_URL + selectedImage}
                    alt="Selected Company Logo"
                    className="w-full h-auto rounded-lg"
                  />
                </div>
              </div>
            )}
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default React.memo(ViewModal);
